export default "<section>\n  <!-- Redirects to QR Menu -->\n</section>\n"